export const UPDATE_COLLECTION_SETS = 'update-collection-sets';
export const UPDATE_COLLECTION_NODE_ENCODING = 'update-collection-node-encoding';
export const UPDATE_COLLECTION_EDGE_ENCODING = 'update-collection-edge-encoding';
export const UPDATE_COLLECTION_NAME = 'update-collection-name';
export const TOGGLE_COLLECTIONS_PANEL = 'toggle-collections-panel';


export const updateCollectionSets = props => ({
    ...props,
    type: UPDATE_COLLECTION_SETS
});

export const updateCollectionNodeEncoding = props => ({
    ...props,
    type: UPDATE_COLLECTION_NODE_ENCODING
});

export const updateCollectionEdgeEncoding = props => ({
    ...props,
    type: UPDATE_COLLECTION_EDGE_ENCODING
});

export const updateCollectionName = props => ({
    ...props,
    type: UPDATE_COLLECTION_NAME
});

export const toggleCollectionsPanel = props => ({
    ...props,
    type: TOGGLE_COLLECTIONS_PANEL
});